<template>
  <div
    v-if="state.type !== 'idle'"
    role="alert"
    aria-live="polite"
    :aria-atomic="true"
    class="mb-4 rounded border px-4 py-3 text-sm"
    :class="variantClass"
  >
    <p class="font-semibold">{{ state.heading }}</p>
    <p class="mt-1 opacity-90">{{ state.message }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { StatusState } from "../composables/useTicketSubmit";

const props = defineProps<{
  state: StatusState;
}>();

const variantClass = computed(() => {
  if (props.state.type === "error") {
    return "border-rose-300 bg-rose-50 text-rose-900";
  }
  if (props.state.type === "success") {
    return "border-emerald-300 bg-emerald-50 text-emerald-900";
  }
  return "border-amber-300 bg-amber-50 text-amber-900";
});
</script>
